'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tablesearch;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Tablesearch(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M16.6363636,5 L6.45454545,5 C5.65122218,5 5,5.65122218 5,6.45454545 L5,15.1818182 C5,15.9851415 5.65122218,16.6363636 6.45454545,16.6363636 L10.28,16.6363636 C9.96,16.1927273 9.72727273,15.7054545 9.55272727,15.1818182 L6.45454545,15.1818182 L6.45454545,12.2727273 L9.57454545,12.2727273 C9.72727273,11.7490909 9.98181818,11.2618182 10.3018182,10.8181818 L6.45454545,10.8181818 L6.45454545,7.90909091 L10.8181818,7.90909091 L10.8181818,10.1709091 C11.2327273,9.72727273 11.7272727,9.38545455 12.2727273,9.13090909 L12.2727273,7.90909091 L16.6363636,7.90909091 L16.6363636,9.13090909 C17.1818182,9.38545455 17.6763636,9.72727273 18.0909091,10.1709091 L18.0909091,6.45454545 C18.0909091,5.65122218 17.4396869,5 16.6363636,5 L16.6363636,5 Z M20.7890909,19.0290909 L19.7563636,20.0618182 L16.4545455,16.76 C15.24,17.56 13.6618182,17.56 12.4472727,16.76 C10.7745455,15.6545455 10.3090909,13.4 11.4145455,11.72 C12.52,10.0472727 14.7818182,9.58181818 16.4545455,10.6872727 C18.1345455,11.7927273 18.5927273,14.0545455 17.4872727,15.7272727 L20.7890909,19.0290909 Z M14.4545455,15.9090909 C15.6595304,15.9090909 16.6363636,14.9322576 16.6363636,13.7272727 C16.6363636,12.5222878 15.6595304,11.5454545 14.4545455,11.5454545 C13.2495605,11.5454545 12.2727273,12.5222878 12.2727273,13.7272727 C12.2727273,14.9322576 13.2495605,15.9090909 14.4545455,15.9090909 Z'
  }));
}
Tablesearch.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};